import { BaseApiRouteService } from "mrb/core";

class LoadioAlbumTrackFileStreamApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio/album-track-file-streams");
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?width,height}`, id, options);
    }
}

export default LoadioAlbumTrackFileStreamApiRouteService;
